var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.449,7.795L13.997,2.62c-0.14-0.132-0.324-0.206-0.517-0.206H5.067c-0.414,0-0.75,0.336-0.75,0.75v17.707 c0,0.414,0.336,0.75,0.75,0.75h13.866c0.414,0,0.75-0.336,0.75-0.75V8.339C19.683,8.133,19.598,7.937,19.449,7.795z M17.638,8.144 h-3.957V4.388L17.638,8.144z M5.817,20.121V3.914h6.364v4.98c0,0.414,0.336,0.75,0.75,0.75h5.252v10.477H5.817z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.851,11.422h-0.683c-0.221,0-0.4,0.179-0.4,0.4v2.41c0,0.221,0.179,0.4,0.4,0.4h0.683c0.885,0,1.605-0.721,1.605-1.605 S12.736,11.422,11.851,11.422z M11.851,13.831h-0.283v-1.609h0.283c0.444,0,0.804,0.361,0.804,0.805 C12.655,13.471,12.295,13.831,11.851,13.831z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.281,11.422H8.284c-0.221,0-0.4,0.179-0.4,0.4v1.556c0,0,0,0.001,0,0.002v0.852c0,0.221,0.179,0.4,0.4,0.4 s0.4-0.18,0.4-0.4v-0.456l0.597-0.004c0.648,0,1.175-0.527,1.175-1.176C10.456,11.948,9.929,11.422,9.281,11.422z M9.278,12.971 l-0.594,0.005v-0.754h0.597c0.207,0,0.375,0.168,0.375,0.374C9.656,12.803,9.487,12.971,9.278,12.971z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.716,11.422h-1.519c-0.221,0-0.4,0.179-0.4,0.4v2.41c0,0.221,0.18,0.4,0.4,0.4s0.4-0.18,0.4-0.4v-0.756h0.991 c0.221,0,0.4-0.18,0.4-0.4s-0.18-0.4-0.4-0.4h-0.991v-0.453h1.118c0.221,0,0.4-0.179,0.4-0.4S15.937,11.422,15.716,11.422z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.ec08bd38c621ec6d2e99e0fd13bd4ee8.svg";
export { ForwardRef as ReactComponent };